import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-timepicker',
  templateUrl: './timepicker.component.html',
  styleUrls: ['./timepicker.component.css'],
})
export class TimepickerComponent implements OnInit {
  @Input() small_input: boolean;
  @Input() time_in_24: boolean;
  @Input() step: number = 5;
  @Input() initial_time: any;
  @Output() time_result: EventEmitter<any> = new EventEmitter();

  hours: Array<number> = [];
  minutes: Array<number> = [];
  selectedHour: number;
  selectedMinute: number;
  meridian: string = 'AM';

  constructor() {}

  // Component lifecycle events
  ngOnInit() {
    this.step = Number(this.step);
    if (this.initial_time) {
      if (typeof this.initial_time.getHours == 'function') this.setTimeByDate(this.initial_time);
      else {
        if (String(this.initial_time.hour)) this.selectedHour = this.initial_time.hour;
        if (String(this.initial_time.minute)) this.selectedMinute = this.initial_time.minute;
        if (this.initial_time.meridian) this.meridian = this.initial_time.meridian.toUpperCase();
      }
    } else this.setTimeByDate(new Date());
    if (this.time_in_24) for (var i = 0; i < 24; i++) this.hours.push(i);
    else {
      for (var i = 1; i < 13; i++) this.hours.push(i);
      if (this.selectedHour > 11) this.meridian = 'PM';
      this.selectedHour = this.selectedHour % 12;
      if (this.selectedHour == 0) this.selectedHour = 12;
    }
    for (var i = 0; i < 60; i += this.step) this.minutes.push(i);
    if (this.selectedMinute % this.step != 0) {
      this.selectedMinute = (Math.floor(this.selectedMinute / this.step) + 1) * this.step;
      if (this.selectedMinute > 59) {
        this.selectedHour += Math.floor(this.selectedMinute / 60);
        this.selectedMinute = Math.floor(this.selectedMinute % 60);
      }
    }
    this.onTimeChange();
  }

  // Component methods
  onMeridianChange() {
    if (this.meridian == 'AM') this.meridian = 'PM';
    else this.meridian = 'AM';
    this.onTimeChange();
  }

  onTimeChange() {
    var hour: any = Number(this.selectedHour);
    var minute: any = Number(this.selectedMinute);
    if (!this.time_in_24)
      if (this.meridian == 'AM') {
        if (hour == 12) hour = 0;
      } else {
        hour += 12;
        if (hour > 23) hour = 12;
      }
    if (hour < 10) hour = '0' + hour;
    if (minute < 10) minute = '0' + minute;
    let result: any = {
      hour: hour,
      minute: minute,
    };
    if (!this.time_in_24) result.meridian = this.meridian;
    this.time_result.emit(result);
  }

  setTimeByDate(date: any) {
    this.selectedHour = date.getHours();
    this.selectedMinute = date.getMinutes();
    if (!this.time_in_24) {
      if (this.selectedHour > 11) this.meridian = 'PM';
      this.selectedHour = this.selectedHour % 12;
      if (this.selectedHour == 0) this.selectedHour = 12;
    }
  }
}
